<template>
  <transition name="fade" mode="out-in" appear>
    <div v-if="isModalOpen" class="modalStack">
      <transition-group name="fade" mode="out-in" appear>
        <modal
          v-for="{ modal, data } in modals"
          v-show="modal.name === activeModal.modal.name"
          :key="modal.name"
          :modal="modal"
          :data="data"
        />
      </transition-group>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Modal from './Modal';

export default {
  name: 'ModalStack',
  components: { Modal },
  computed: {
    ...mapState('modal', ['modals']),
    ...mapGetters('modal', ['isModalOpen', 'activeModal']),
  },
};
</script>

<style lang="scss">
.modalStack {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($cMainDark, 0.5);
  z-index: $zPopup;
  padding: 3rem;

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity $tr;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
